export const hash = 'c2a7a47b-ffbf-415e-a540-4f67f5dd7456';

// export const gateKey = '';
export const gateKey = 'ek_live_g5Df6bp6y5ptAKeOVOpBloZHmqY0sb';
export const recaptchaKey = '6Ld9r7cZAAAAABw5wijiLD5PhlWqLivIN9NqFKi_';
export const apiUrl = `https://api-global-v3.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br';



//export const apiSocket = 'http://localhost:8080';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const websitePath = 'https://congresso-ufcspa.encontrodigital.com.br';
export const urlWebsite = 'https://congresso2025.ufcspa.edu.br';
export const supportNumber = `555195181533`;
export const home = 'Home';
export const haveTranslate = false;
export const defaultProjectHash = 'evento';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = '4º Congresso UFCSPA';
export const logo = '/assets/logo.png';
export const background = '/assets/Fundo.jpg';
export const authTitle = '4º Congresso UFCSPA';
export const dadosOrganizacao = '';
export const social = {
    whatsapp: '',
    instagram: '',
    facebook: '',
    linkedin: '',
    youtube: '',
    spotify: '',
    twitter: '',
};


export const defaultTheme = {
    defaultBackground: '#38a5df',
    defaultColor: '#fff',
    logo: {
        minWidth: '450px',
    },
    menu: {
        background: '#38a5df',
        backgroundSticky: '#38a5df',
        backgroundMobile: '#38a5df',
        color: '#fff',
        shadow: '0',
        logoColor: 'none',
    },
};

export const getToken = (): string | null => {
    const token = localStorage.getItem(`@${authTitle}:token`);
    return token;
};
